export default __webpack_public_path__ + "static/media/212901.57aa0f12.jpg";